import React, { useEffect, useState, useCallback } from "react";
import { RefreshCw } from "lucide-react";
import { useParams } from "react-router-dom";
import { apiClient } from "../api/apiClient";

export default function UserJobs() {
  const { user_id } = useParams();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchJobs = useCallback(async () => {
    try {
      setLoading(true);
      const res = await apiClient.get(`/user-jobs/${user_id}`);
      setJobs(res.data?.jobs || []);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setLoading(false);
    }
  }, [user_id]);

  useEffect(() => {
    if (user_id) fetchJobs();
  }, [user_id, fetchJobs]);

  return (
    <div className="min-h-screen bg-bg text-text-primary px-6 py-10">

      {/* Page Title */}
      <h1 className="text-4xl font-bold mb-10 tracking-wide text-center text-text-primary">
        Your Migration Jobs
      </h1>

      {/* Refresh Button */}
      <div className="flex justify-center mb-10">
        <button
          onClick={fetchJobs}
          className="flex items-center gap-2 px-5 py-3 bg-white border border-border hover:border-border-strong hover:bg-bg-soft rounded-xl transition-all duration-300 shadow-md hover:shadow-lg text-text-primary"
        >
          <RefreshCw size={19} />
          <span className="tracking-wide font-medium">Refresh List</span>
        </button>
      </div>

      {/* Job List Container */}
      <div className="space-y-5 max-w-3xl mx-auto">

        {loading && (
          <p className="text-text-muted text-center">Fetching your jobs...</p>
        )}

        {!loading && jobs.length === 0 && (
          <p className="text-text-muted text-center italic">
            No migration jobs found.
          </p>
        )}

        {jobs.map((job, i) => (
          <div
            key={i}
            className="bg-white border border-border hover:border-border-strong transition-all duration-300 p-6 rounded-2xl shadow-sm hover:shadow-md"
          >
            <div className="flex justify-between items-start">

              {/* Left Info */}
              <div className="space-y-1">
                <p className="text-xl font-semibold tracking-wide text-text-primary">
                  {job.job_name}
                </p>

                <p className="text-sm text-text-secondary">
                  Created on:{" "}
                  <span className="text-text-primary">
                    {new Date(job.created_at).toLocaleString()}
                  </span>
                </p>

                <p className="text-sm text-text-muted">
                  Job ID: <span className="text-text-secondary">{job.job_id}</span>
                </p>
              </div>

              {/* Status Chip */}
              <span
                className={`px-4 py-1.5 rounded-full text-sm font-medium tracking-wide border
                  ${
                    job.status === "completed"
                      ? "bg-green-50 border-green-400 text-green-700"
                      : job.status === "failed"
                      ? "bg-red-50 border-red-400 text-red-700"
                      : "bg-bg-soft border-border text-text-muted"
                  }
                `}
              >
                {job.status || "pending"}
              </span>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
}